import { compose as o } from "../../tailwind-buddy-interface.js";
const t = o({
  slots: {
    root: (
      /** @tw */
      "flex items-start p-100 rounded-md"
    ),
    icon: (
      /** @tw */
      "shrink-0"
    ),
    content: (
      /** @tw */
      "grow flex flex-col gap-y-100 py-075 ps-100 pe-100"
    ),
    closeButton: (
      /** @tw */
      "shrink-0"
    )
  },
  variants: {
    /** Sets the severity appearance. */
    severity: {
      informative: {
        root: (
          /** @tw */
          "bg-color-scheme-functional-informative-100 text-color-scheme-functional-informative-800"
        ),
        icon: (
          /** @tw */
          "text-color-scheme-functional-informative-400"
        )
      },
      positive: {
        root: (
          /** @tw */
          "bg-color-scheme-functional-positive-100 text-color-scheme-functional-positive-800"
        ),
        icon: (
          /** @tw */
          "text-color-scheme-functional-positive-400"
        )
      },
      notice: {
        root: (
          /** @tw */
          "bg-color-scheme-functional-notice-100 text-color-scheme-functional-notice-800"
        ),
        icon: (
          /** @tw */
          "text-color-scheme-functional-notice-400"
        )
      },
      negative: {
        root: (
          /** @tw */
          "bg-color-scheme-functional-negative-100 text-color-scheme-functional-negative-800"
        ),
        icon: (
          /** @tw */
          "text-color-scheme-functional-negative-400"
        )
      }
    }
  },
  responsiveVariants: [],
  defaultVariants: {
    severity: "informative"
  }
})();
export {
  t as alertVariants
};
